import { captchaV3Actions, captchaV3SiteKey } from 'assets/data/config';
import type { IActionKey } from '~/interfaces/form/grecaptcha';

export default () => {
  const site = useSiteStore();
  const siteKey = captchaV3SiteKey[site.getEnvironment];

  const executeRecaptcha = async (
    actionKey: IActionKey,
  ): Promise<string | undefined> => {
    const captcha = window?.grecaptcha;

    if (!captcha) {
      if (
        window.location.hostname.includes('localhost') ||
        site.getEnvironment === 'development'
      ) {
        console.error('reCAPTCHA script not loaded');
      }
      return;
    }

    try {
      await new Promise((resolve) => captcha?.ready(resolve));
      const action = captchaV3Actions.get(actionKey);
      if (!action) {
        throw new Error(`Invalid action key: ${actionKey}`);
      }

      return await captcha.execute(siteKey, action);
    } catch (error) {
      console.error('reCAPTCHA error:', error);
      throw error;
    }
  };

  return {
    executeRecaptcha,
  };
};
